import { styled } from '@lichtblick/styled';
import { Spacing } from '@lichtblick/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export const ListContainer = styled.div`
  height: 100vh;
  max-width: 20rem;
  overflow-y: auto;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${Spacing.Xs};
  padding: ${Spacing.S};
`;

export const CheckboxContainer = styled.div`
  padding: ${Spacing.S};
`;
